import React from 'react';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

interface CheckboxIconType {
  icon: React.ReactNode;
  checkedIcon: React.ReactNode;
}

export const CheckboxIcon: CheckboxIconType = {
  icon: <CheckBoxOutlineBlankIcon fontSize="small" />,
  checkedIcon: <CheckBoxIcon fontSize="small" />,
};
